import {useRouter} from 'next/router';
import {useMemo} from 'react';
import {CART_ROUTE} from 'core/modules/routing/constants';
import {isPage} from 'core/helpers';

export const useIsCartPage = (): boolean => {
    const router = useRouter();

    return useMemo<boolean>(() => {
        return isPage(CART_ROUTE, router.pathname);
    }, [router.pathname]);
};
